module.exports = __webpack_public_path__ + "static/media/GrabPay.7f3ebb87.png";